var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHotelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 20,
    viewBox: "0 0 33 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hotel-room 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hotel_Room"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_646_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1323_",
    opacity: 0.1,
    d: "M29.8333 22.2223H24.5C24.2544 22.2223 24.0555 22.0234 24.0555 21.7778V18.2223C24.0555 17.9778 24.2555 17.7778 24.5 17.7778H29.8333C30.0778 17.7778 30.2778 17.9778 30.2778 18.2223V21.7778C30.2778 22.0234 30.0789 22.2223 29.8333 22.2223Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1322_",
    opacity: 0.1,
    d: "M21.3888 20.2222V17.3333C21.3888 16.6 20.7888 16 20.0555 16H4.0555C3.32217 16 2.72217 16.6 2.72217 17.3333V20.2222H21.3888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1321_",
    d: "M20.9444 22.2222H3.16661C2.92106 22.2222 2.72217 22.0233 2.72217 21.7778V17.3333C2.72217 16.6 3.32217 16 4.0555 16H20.0555C20.7888 16 21.3888 16.6 21.3888 17.3333V21.7778C21.3888 22.0233 21.1899 22.2222 20.9444 22.2222Z",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1320_",
    d: "M29.8333 22.2223H24.5C24.2544 22.2223 24.0555 22.0234 24.0555 21.7778V18.2223C24.0555 17.9778 24.2555 17.7778 24.5 17.7778H29.8333C30.0778 17.7778 30.2778 17.9778 30.2778 18.2223V21.7778C30.2778 22.0234 30.0789 22.2223 29.8333 22.2223Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1319_",
    d: "M2.72217 20.2223H21.3888",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1318_",
    d: "M4.27771 23.1112V22.2223",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1317_",
    d: "M19.8333 23.1112V22.2223",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1316_",
    d: "M24.9443 23.1112V22.2223",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1315_",
    d: "M29.3888 23.1112V22.2223",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1314_",
    d: "M11.611 16.0001H5.38878C5.14434 16.0001 4.94434 15.8001 4.94434 15.5556C4.94434 14.5778 5.74434 13.7778 6.72211 13.7778H10.2777C11.2554 13.7778 12.0554 14.5778 12.0554 15.5556C12.0554 15.8001 11.8554 16.0001 11.611 16.0001Z",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1313_",
    d: "M18.7222 16.0001H12.5C12.2555 16.0001 12.0555 15.8001 12.0555 15.5556C12.0555 14.5778 12.8555 13.7778 13.8333 13.7778H17.3889C18.3667 13.7778 19.1667 14.5778 19.1667 15.5556C19.1667 15.8001 18.9667 16.0001 18.7222 16.0001Z",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1312_",
    d: "M26.5 20H27.8333",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1311_",
    d: "M27.1667 13.3334C25.6113 13.3334 25.6113 14.3434 25.6113 15.5556C25.6113 16.7678 26.6078 17.7778 27.1667 17.7778C27.7256 17.7778 28.722 16.7678 28.722 15.5556C28.722 14.3434 28.7949 13.3334 27.1667 13.3334Z",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1310_",
    d: "M24.2777 12.8889H30.2777L28.0555 8.88892H26.2777L24.2777 12.8889Z",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotelIcon);
export default __webpack_public_path__ + "static/media/hotel-icon.ad0acf560169d06327af823972402e35.svg";
export { ForwardRef as ReactComponent };